var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5 10"}},_vm.$listeners),[_c('path',{attrs:{"fill":"none","stroke":"#222","d":"M.5 9.5l4-4.5L.5.5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }